export default function UniversitiesSection() {
  return (
    <section className="py-28 px-6 lg:px-12 relative overflow-hidden">
      {/* Subtle gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#304FFE]/[0.03] via-transparent to-[#7C4DFF]/[0.03]"></div>

      <div className="max-w-5xl mx-auto text-center relative z-10">
        {/* Icon */}
        <div className="w-16 h-16 bg-gradient-to-br from-[#304FFE] to-[#7C4DFF] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
          <i className="ri-building-line text-3xl text-white"></i>
        </div>

        {/* Title */}
        <h2 className="text-4xl lg:text-5xl font-bold text-[#1A1F36] mb-6">
          For Universities & Bootcamps
        </h2>

        {/* Description */}
        <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-10 leading-relaxed">
          Partner with Praxia to attract motivated learners validated through Skill Badges, Microcredentials and Merit Pathways.
        </p>

        {/* CTA Button */}
        <a
          href="/partners"
          className="inline-flex items-center gap-3 bg-gradient-to-r from-[#304FFE] to-[#7C4DFF] text-white font-bold px-10 py-5 rounded-full hover:shadow-[0_20px_40px_rgba(124,77,255,0.3)] hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap text-lg"
        >
          Learn More for Institutions
          <i className="ri-arrow-right-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}
